module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph"
  }, [_c('p', {
    staticClass: "chapterEpigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“There’s naught worse than a man who thinks he’s always right—’cept a woman who always is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LD")]), _vm._v(" W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OMAN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORA TO HER THREE WEE GRANDDAUGHTERS ON A COLD WINTER’S NIGHT")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I")])])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("forbid")]), _vm._v(" you to go.” Though merely twenty years old, William Hurst thought himself in charge of Wythburn Vicarage when his father was away. “Be warned, Triona,” he added in his deepest voice. “I will do everything in my power to halt this madness!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His oldest sister didn’t even look up from digging out a worn portmanteau from her wardrobe. Caitriona—Triona to her family—placed the case on her bed and snapped it open, then began packing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Did you hear me?” William said more loudly, “I forbid—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What? Oh, yes, I heard you. But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("someone")]), _vm._v(" has to go to London and talk some sense into Caitlyn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Since Father and Mother are visiting Uncle Traveres for two more weeks, and you are in the midst of preparing for your exams, that someone will have to be me.”")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("William scowled. A handsome young man possessing considerable height, he was used to being paid more heed. Everyone in the county deferred to him, except his own family, even when he wore his high-collared coat of blue superfine, his cravat tied in an impressive array of knots. “You are not Caitlyn’s keeper.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" her twin sister, so it falls on me to help her out of this mess she’s made.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“William, leave Triona be.” Eighteen-year-old Robert stood by the door, his arms wrapped around a huge tome, and smirked at his older brother. “Father expressly placed Triona in charge when he left. I heard him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William scowled. “Father didn’t intend her to go running off to London. As I’m the oldest male, that should be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona adjusted her spectacles more securely on her nose and laughed. “Ah! I see; you don’t wish to miss out on the fun. Well, I promise I won’t stay long enough to have any.” She crossed her fingers and held them up, saying primly, “Promise is as promise does.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William sighed. “I don’t mind you having fun. I just don’t wish you to find yourself in an awkward situation. A female—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who is twenty-three years of age.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“—traveling alone—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nurse is going with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“—to the most licentious city on earth, a den of iniquity and vice—”")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Ooh! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Very")]), _vm._v(" well said!” She looked him up and down in admiration. “Is that from one of Father’s sermon books?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William couldn’t stop a sheepish grin. “You know what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I do, and I promise to be careful. But I’m the only one Caitlyn will listen to, so I must go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“William!” Seventeen-year-old Mary dropped her knitting with a huff of irritation. “This is an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("emergency")]), _vm._v("! Caitlyn is acting so badly that poor Aunt Lavinia was forced to write for assistance!” Her lips quivered. “After this, Aunt Lavinia will "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" invite any of us to stay with her for a season!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William sighed. “I’m not saying we shouldn’t rescue Caitlyn from whatever mischief she’s bent on; I just wish we could ask Father’s opinion on how to deal with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, you don’t,” Michael said sharply from beside the fire, wrapped in a blanket to ward off the room’s chill. Thin and pale and given to a weak chest, he possessed a sharp wit and a sharper mind that outstripped his fifteen years. Having caught the same ague that had kept Triona from enjoying a season in London with Caitlyn, he had not yet recovered, with an unnatural flush still coloring his thin cheeks and a wretched cough that lingered. “Father is the last person to notify about this. If he knew how badly Caitlyn has been behaving, he’d never allow another of us to visit Aunt Lavinia.”")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Mary chimed in, “It took "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("months")]), _vm._v(" to get him to agree to allow Caitlyn and Triona to go, and when Triona became ill and couldn’t travel, he tried to cancel the entire trip and Mother had to intervene and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know!” William said, clearly exasperated. “I was here, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then you should know that telling Father anything negative would be a colossal error.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael nodded. “Mary’s right. Father would—” He coughed, a long, racking effort that sounded as if his toes might curl inside out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona paused in folding her silver-threaded shawl and gave him a worried glance. The vicarage at Wythburn was a rambling, drafty house given to mysterious creaks and leaks. Besides the uneven stairs that leaned to one side and warped floorboards that no amount of nails could hold flat, cold gusts rattled the doors and windows and kept damp corners from drying out properly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She frowned at her youngest brother. “Are you taking your medicine?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael grimaced. “No.” Before she could protest, he added sullenly, “It makes me too sleepy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sleep would be good for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" is sleep. I’m rested enough as it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William frowned. “You can’t tell me you slept well last night, for I heard you coughing well into the morning hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona pointed to the bottle at Michael’s elbow. “Take it.”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She set her hands on her hips. “Michael John Hurst, don’t make me sing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William turned to his brother. “Michael, take that medicine!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Please,”")]), _vm._v(" Mary pleaded fervently.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clutching his book, Robert pointed to the bottle. “For all our sakes!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael gave a weak laugh that turned into another racking cough. When he could breathe again, he picked up the bottle and a spoon. “Fine, but only because I feel sorry for all of you. I don’t mind if Triona sings to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How can you not?” Mary asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He grinned. “Because this ague has stopped up my ears. You all sound like you’re very far away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona waited to make sure he took a full dose, then turned back to her packing. “If all goes well, I should be back from London before Father returns. And if I can secure Aunt Lavinia’s silence, he need never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mary brightened. “Then he might not protest if she invites another of us to visit her for a season!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona nodded. If Mary didn’t eat too many crème tarts, she might well rival Caitlyn in looks one day. Meanwhile, Caitlyn was in full bloom, and it was difficult to imagine a more winsome beauty.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("Although Triona and Caitlyn were twins and enjoyed some similarities, there were many more differences between them. Caitlyn was small and slim with golden ")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("hair, tilted dark brown eyes, a heart-shaped face, and a mesmerizingly graceful way of floating across a room that left men standing mouths agape, their eyes glued to her. Triona was tall and more rounded, her hair more brown than gold, her hazel eyes hidden by spectacles and lacking the tilt that made Caitlyn’s so compelling. And no matter how Triona tried, she couldn’t float across the room any more than she could trim a few inches off her ungainly height.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But it was more than that. It was the way Caitlyn laughed, and charmed, and…oh, Triona couldn’t define it. Neither could the dozens of besotted young men who’d attempted to describe Caitlyn’s charms in laughably bad poetry and gushing conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Before Triona leaves, we must all do one thing,” Michael said, his tone unyielding. “We must all vow not to tell Father about Triona’s trip. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All")]), _vm._v(" of us.” He gave Robert a pointed stare.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” William said immediately, his gaze locked on Robert as well. “We must "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" vow to keep our mouths closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert turned a dull red. “I won’t vow any such thing! Father wouldn’t wish us to keep secrets from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert had won Father’s approval by applying himself to his studies in a way that left his siblings glaring at him from their respective corners of the dinner table, especially when he smugly answered one of Father’s more esoteric questions in flawless Greek or Latin.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("“Perhaps you don’t understand the situation.” Tri")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("ona picked up a letter from the bed and handed it to Robert. “Aunt Lavinia is at wit’s end to know what to do. As much as I esteem our aunt for her good nature and generosity, we all know how Caitlyn can be at times.”")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Mary nodded. “No one is more stubborn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Or impulsive.” Michael’s voice was faintly slurred, the medicine beginning to take effect.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert read the missive, then gave a snort of disgust. “Aunt Lavinia can’t think ordering Caitlyn about will help things! It will only make her more determined to do worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William sighed. “It doesn’t matter how badly Caitlyn mulls things—none of us have the funds to visit London, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But just think,” Mary said earnestly. “If Caitlyn makes an advantageous marriage, she can invite us to stay with her in London and take us to balls and plays and all sorts of events!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona smiled dreamily, placing two books into her portmanteau. “I should like to see the British Museum.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert brightened. “By Jove, that would be something! I heard the Elgin Marbles are on display.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael said, “I’d like to go see Tattersalls auction house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On her way to fetch her half boots from the wardrobe, Triona paused by the settee to muss Michael’s hair. “That would be lovely,” she agreed.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("William’s eyes shone. “I’d like to see that, too! And ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Gentleman Jackson’s Boxing Saloon, and Vauxhall Gardens, and—”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Triona laughed. “Caitlyn had better marry a man with a very, very large house so we will all fit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And she would certainly let us stay with her, for she’s very generous,” Mary said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And foolish,” Robert added. “And impulsive and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William balled his hands into fists.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, she is!” Robert eyed his older brother’s fists and added hastily, “Not that it’s her fault. Caitlyn’s behavior is evidence of the decadent influence of London society—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, please.” Triona folded a night rail. “Caitlyn was just as impetuous and unthinking while here in the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She wasn’t such a flirt,” Robert insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, she was,” Triona said in a regretful tone. “Poor Mr. Smythe-Laughton went into a decline when she left for London, and then there was Mr. Lyndon, and Lord Haversham’s eldest, and—oh, more than I can count.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There were dozens,” Mary agreed enviously. “Father warned her of it several times, though I heard him telling Mother that Caitlyn didn’t realize her effect on men and that, in general, he thought her flirting very innocent, though he couldn’t help worrying that it might be her undoing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert sniffed. “Father has been much too indulgent.”")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll be sure to tell him you said that,” Triona said dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Please don’t!” Robert said so fervently that Triona laughed. He grinned in return. “Maybe I am being a bit harsh, but you must agree that London has had an unfortunate effect on Caitlyn. She might have flirted more than was seemly here, but she wasn’t so lost to decorum as to declare in front of an entire ballroom that she was going to marry someone before the end of the year, ‘one way or another.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not unless she was goaded,” Michael pointed out. “Caitlyn’s quick to take umbrage, so perhaps it was due to something Alexander MacLean said or did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona wrapped a pair of shoes in brown paper and placed them in the portmanteau. “Grandmother is forever telling us about the MacLean pride; sometimes I think she would do better to warn us about the Hurst pride. It is just as formidable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mam loves to talk about the MacLean curse,” Mary said with a delicious shiver. “An entire family, cursed to cause storms whenever they lose their tempers! Just imagine!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William’s eyes twinkled as he curled his hands into claws and hunched his shoulders, saying in an old-woman brogue, “Don’t ye be forgettin’, me dearies, the MacLeans were cursed! Cursed, I tell ye, by the mysterious white witch. Now when they lose their tempers, the storms do fly!”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Everyone chuckled except Mary. “You shouldn’t ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("mock Mam. She’s a very wise old woman. Father says half the village wouldn’t be alive if not for her knowledge of healing and herbs. Besides, who’s to say that there’s no such thing as a curse?”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Father, for one,” Robert said. “He says it’s all nonsense. And as Mam is his mother, I’d think he’d know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael moved restlessly on the settee. “Whatever the truth about MacLean, he can’t be happy with Caitlyn making such a spectacle of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It sounds as if "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("both")]), _vm._v(" Caitlyn and MacLean have been misbehaving. Fortunately, we are not responsible for MacLean.” Triona placed her portmanteau by the door, then gathered her cloak, scarf, and good bonnet. “I hear the carriage at the front door, and I daresay Nurse is waiting for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael smiled sleepily. “Good luck, Triona. Remember, Father is due back a week from Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Which is why I plan on being home at least two days before that, at the latest. Father will never be the wiser if we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v("”—she looked at Robert—“keep our mouths closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And if you don’t,” Mary said smugly, “I shall tell Father who spilled milk all over his favorite copy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Odyssey.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Robert started. “How did you know—” At Mary’s amused gaze, he colored.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So either hold your tongue, or face Father’s wrath,” she warned.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Robert flung up a hand. “Fine! But if some ill comes ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("of this trip, I will tell Father I attempted to warn Triona against it.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Triona pulled a pair of old gloves from her cape pocket and put them on. “Oh, Robert, stop being so gloomy. Nothing ill will come of this. Besides, Father said I could visit London once he returned. You could say I’m only going earlier than planned.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Father wanted to escort you himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And so he shall—next time.” Triona glanced in the mirror and tucked a stray strand of hair into her bonnet. “Time to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William bent to collect her portmanteau. “If I didn’t know that Mr. Olson would inform Father if I missed a tutoring appointment, I would go with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona smiled at her brother. “It does my heart good to know that you’re willing to make such a sacrifice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("William grinned. “It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("would")]), _vm._v(" be a grand lark.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona laughed, then turned to Robert. “Stop glowering and give me a hug good-bye. I shall miss you!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His stern expression softened and he complied.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Next was Michael. She bent and gave him an especially big hug. “Stay inside and make sure you take the medicine Dr. Felters left for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Michael scrunched his nose, his brown eyes large in his thin face. “If I must.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You must.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She looked at Mary, who hugged Triona and whispered, “I’ll keep an eye on Michael. Don’t worry about a thing.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("“Thank you.” Triona smiled at her younger sister ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("and, with a grin, said loudly, “You’re in charge, Mary. Make sure William meets with his tutor, and Michael gets his medicine, and Robert doesn’t pour milk on any more books, and—”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Over the protests of her brothers, Mary laughed. “I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Excellent! Good-bye, my dears. I will return as soon as I have cooled Caitlyn’s spirits a bit.” Triona went downstairs, William following with her portmanteau.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Smiling, she greeted Nurse and continued to the carriage, her mind already leaping ahead to London. Despite her cheery words to her siblings, she couldn’t help but worry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona’s earliest memory was of watching Caitlyn trying to climb the banister to slide down it, though they’d been expressly told not to. Later, her leg in a cast, Caitlyn had told Mother and Father she was glad she’d done it, because it’d been such fun.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even at age five Caitlyn had been a handful, while Triona had dutifully gone about life, never giving her parents a moment’s fear. Her parents never knew how often Triona intervened to keep Caitlyn from falling into worse scrapes, either. Triona understood her twin sister better than most; she knew how Caitlyn’s restless spirit made her yearn for excitement. There was little Caitlyn loved better than the chaos that magically appeared everywhere she went. She didn’t exactly start it, but she rarely did anything to halt it once it began.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Triona, meanwhile, prized order above all things. And as the oldest, she was frequently called upon to provide exactly that for her many siblings. So rescuing Caitlyn now from yet another scrape was nothing new, and yet, somehow, Triona couldn’t shake the feeling that this time something was different.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Caitlyn, what are you into now?")])])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a69d939a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781439164341_ch01.vue
// module id = 84
// module chunks = 0